<template lang="html">
  <v-container fluid>
    <base-items
      ref="baseItems"
      storeModule="payments"
      loadOnTrigger
      :filter="appliedPaymentsFilter"
      @items="items = $event"
      @state="state = $event"
      @error="onError"
    ></base-items>
    <v-row justify="space-around">
      <v-col cols="12" md="4">
        <div class="headline">
          Orders
        </div>
      </v-col>
      <v-col cols="12" md="7" class="hidden-sm-and-down">
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            Filter
            <v-spacer/>
            <v-btn :color="filterChanged ? 'primary' : 'grey lighten-3'" @click="applyFilter">Apply</v-btn>
          </v-card-title>

          <v-card-text>

            <v-divider class="mb-4" />

            <h2>Specific payments</h2>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Receipt Id"
                  v-model="receiptId"
                  autocomplete="off"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Payment Serial number"
                  :value="paymentSerialNr"
                  @input="paymentSerialNr = $event && helpZeros ? padleft($event, '0', 9) : null"
                  clearable
                  autocomplete="off"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Z-Report Serial number"
                  :value="zReportSerialNr"
                  @input="zReportSerialNr = $event && helpZeros ? padleft($event, '0', 8) : null"
                  clearable
                  autocomplete="off"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Point Of Sale"
                  v-model="pointOfSale"
                  clearable
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <h2>Date &amp; time</h2>

            <v-row>
              <v-col cols="12" sm="6">
                <date-input v-model="dateFrom" :max="today" label="Date from"></date-input>
              </v-col>
              <v-col cols="12" sm="6" class="mt-n5 mt-sm-0 mb-3 mb-sm-0">
                <time-input
                  class=""
                  v-model="timeFrom"
                  label="Time from"
                  clearable
                  :disabled="!dateFrom"
                  :messages="dateFrom ? '' : 'Requires a date'"
                ></time-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <date-input v-model="dateTo" :max="today" label="Date to"></date-input>
              </v-col>
              <v-col cols="12" sm="6" class="mt-n5 mt-sm-0">
                <time-input
                  class=""
                  v-model="timeTo"
                  label="Time to"
                  clearable
                  :disabled="!dateTo"
                  :messages="dateTo ? '' : 'Requires a date'"
                ></time-input>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <h2>Operator</h2>
            <div class="">
              <v-checkbox
                v-for="operator in operators"
                :key="operator.value"
                :input-value="selectedOperators.indexOf(operator.value) != -1"
                @change="toggleSelected(selectedOperators, operator, $event)"
                :label="operator.text"
                color="primary"
                hide-details
              ></v-checkbox>
            </div>

            <v-divider class="my-4" />

            <h2>Status</h2>
            <div class="">
              <v-checkbox
                v-for="status in statuses"
                :key="status.value"
                :input-value="selectedStatuses.indexOf(status.value) != -1"
                @change="toggleSelected(selectedStatuses, status, $event)"
                :label="status.text"
                color="primary"
                hide-details
              ></v-checkbox>
            </div>

            <v-divider class="my-4" />

            <h2>Payment method</h2>
            <div class="">
              <v-checkbox
                v-for="method in paymentMethods"
                :key="method.value"
                :input-value="selectedPaymentMethods.indexOf(method.value) != -1"
                @change="toggleSelected(selectedPaymentMethods, method, $event)"
                :label="method.text"
                color="primary"
                hide-details
              ></v-checkbox>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn text @click="reset">Reset</v-btn>
          </v-card-actions>
        </v-card>

        <v-card class="mt-8">
          <v-card-title>
            Options
          </v-card-title>

          <v-card-text>
            <v-checkbox
              label="Auto add zeros for serial numbers"
              v-model="helpZeros"
            ></v-checkbox>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title>
            Results
          </v-card-title>
          <v-card-text>
            <div v-if="state.loading" class="">
              <v-progress-circular color="primary" indeterminate></v-progress-circular>
            </div>
            <div v-else-if="payments.length > 0" class="">
              <p>
                {{paymentsTotal.purchases.length}} orders and {{paymentsTotal.refunds.length}} refunds.
              </p>
              <p>
                {{paymentsTotal.itemCount}} items ({{paymentsTotal.purchasesItemsCount}} items sold, {{paymentsTotal.refundsItemsCount}} items refunded)
              </p>
              <p>
                Sales totalling {{paymentsTotal.purchasesAmount.gross.toFixed(2)}} SEK gross ({{paymentsTotal.purchasesAmount.net.toFixed(2)}} SEK net)
              </p>
              <p>
                Refunds totalling {{paymentsTotal.refundsAmount.gross.toFixed(2)}} SEK gross ({{paymentsTotal.refundsAmount.net.toFixed(2)}} SEK net)
              </p>
              <p>
                Grand total {{paymentsTotal.amount.gross.toFixed(2)}} SEK gross ({{paymentsTotal.amount.net.toFixed(2)}} SEK net)
              </p>
              <v-list>
                <v-list-item
                  v-for="payment in payments"
                  :key="payment.id"
                  three-line
                  ripple
                  link
                  @click="openPayment(payment)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{payment.operatorName}}</v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="d-flex align-center my-1">
                        <v-icon small left>{{payment.transactionType == 'REFUND' ? 'mdi-cash-refund' : 'mdi-basket'}}</v-icon>
                        <span>{{payment.transactionType == 'REFUND' ? 'Refund' : 'Purchase'}}</span>
                      </div>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <span>Status: </span>
                      <span class="font-weight-bold" :class="payment._status ? payment._status.color + '--text' : ''">{{payment._status ? payment._status.text : payment.status}}</span>
                      <span v-if="payment.reversal">, Reversal</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{(payment.items || []).length}} items, total {{getAmount(payment)}} SEK. Ordered at {{!payment.datePaid || payment.datePaid == 'None' ? moment(payment.dateCreated).format('YYYY DD MMM HH:mm') : moment(payment.datePaid).format('YYYY DD MMM HH:mm')}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="">
              No orders
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog :value="!!selectedPayment" @input="closePayment" max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          Order details
          <div class="d-inline-block ml-4">
            <div
              v-if="(selectedPayment || {}).transactionType == 'REFUND'"
              class="d-flex flex-row align-center red--text text--darken-1"
            >
              <span>Refund</span>
              <v-icon class="ml-2 red--text text--darken-1">mdi-cash-refund</v-icon>
            </div>
            <div v-else
              class="d-flex flex-row align-center green--text text--darken-1"
            >
              <span>Purchase</span>
              <v-icon class="ml-2 green--text text--darken-1">mdi-basket</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <payment :item="selectedPayment" @open-payment="openPaymentById"/>
        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="closePayment">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import {BaseItems} from 'dync-baseitem'
import {DateInput, TimeInput} from 'dync-datetime';
import Payment from '../components/Payment.vue';
import moment from 'moment-timezone'

export default {
  data () {
    return {
      moment,
      datemenu: false,
      today: moment().format('YYYY-MM-DD'),
      receiptId: '',
      paymentSerialNr: '',
      zReportSerialNr: '',
      pointOfSale: '',
      dateFrom: null,
      dateTo: null,
      timeFrom: '',
      timeTo: '',
      items: [],
      state: {},
      selectedStatuses: ['PAID', 'REDEEMED', 'DEBITED'],
      selectedOperators: [],
      selectedPaymentMethods: [],
      filterChanged: true,
      appliedPaymentsFilter: null,
      selectedPayment: null,
      helpZeros: true
    };
  },
  watch: {
    paymentsFilter () {
      this.filterChanged = true;
    },
    dateFrom (val) {
      if (!val) {
        this.timeFrom = '';
      }
    },
    dateTo (val) {
      if (!val) {
        this.timeTo = '';
      }
    }
  },
  computed: {
    payments () {
      var payments = this.items.slice(0);
      payments = payments.map((payment) => {
        payment = Object.assign({}, payment);
        payment._status = this.getStatus(payment.status);
        if (payment.datePaid == 'None') {
          payment.datePaid = null;
        }
        return payment;
      });
      payments.sort((a, b) => {
        var aValue = a.datePaid || a.dateCreated;
        var bValue = b.datePaid || b.dateCreated;
        if (aValue < bValue) {
          return 1;
        } else if (aValue > bValue) {
          return -1;
        } else {
          return 0;
        }
      })
      return payments;
    },
    paymentsFilter () {
      var result = {};
      // Receipt id
      if (this.receiptId) {
        if (!result.keyValue) {
          result.keyValue = [];
        }
        result.keyValue.push(['payeePaymentReference', this.receiptId]);
      }
      // Point Of Sale
      if (this.pointOfSale) {
        if (!result.keyValue) {
          result.keyValue = [];
        }
        result.keyValue.push(['pointOfSale', this.pointOfSale]);
      }
      // Payment serial number id
      if (this.paymentSerialNr) {
        if (!result.keyValue) {
          result.keyValue = [];
        }
        result.keyValue.push(['serialNumber', this.paymentSerialNr]);
      }
      // Z-Report id/serial number
      if (this.zReportSerialNr) {
        if (!result.keyValue) {
          result.keyValue = [];
        }
        result.keyValue.push(['paymentLockId', this.zReportSerialNr]);
      }
      // Date and time
      var datetimeFrom, datetimeTo;
      if (this.dateFrom) {
        if (this.timeFrom) {
          datetimeFrom = moment(this.dateFrom + ' ' + this.timeFrom, 'YYYY-MM-DD HH:mm');
        } else {
          datetimeFrom = moment(this.dateFrom, 'YYYY-MM-DD').subtract(1, 'days').endOf('day');
        }
      }
      if (this.dateTo) {
        if (this.timeFrom) {
          datetimeTo = moment(this.dateTo + ' ' + this.timeTo, 'YYYY-MM-DD HH:mm');
        } else {
          datetimeTo = moment(this.dateTo, 'YYYY-MM-DD').add(1, 'days').startOf('day');
        }
      }
      if (datetimeFrom) {
        result.greaterThan = [
          ['dateCreated', datetimeFrom.tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z']
        ];
      }
      if (datetimeTo) {
        result.lessThan = [
          ['dateCreated', datetimeTo.tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z']
        ];
      }
      // Statuses
      if (this.selectedStatuses.length > 0) {
        if (!result.keyValueIn) {
          result.keyValueIn = [];
        }
        result.keyValueIn.push(['status', this.selectedStatuses]);
      }
      // Operators
      if (this.selectedOperators.length > 0) {
        if (!result.keyValueIn) {
          result.keyValueIn = [];
        }
        result.keyValueIn.push(['operatorId', this.selectedOperators]);
      }
      // Payment Methods
      if (this.selectedPaymentMethods.length > 0) {
        if (!result.keyValueIn) {
          result.keyValueIn = [];
        }
        result.keyValueIn.push(['paymentType', this.selectedPaymentMethods]);
      }
      return result;
    },
    statuses () {
      return [
        {
          'text': 'Created',
          'value': 'CREATED',
          'color': 'blue'
        },
        {
          'text': 'Declined',
          'value': 'DECLINED',
          'color': 'grey'
        },
        {
          'text': 'Paid',
          'value': 'PAID',
          'color': 'green'
        },
        {
          'text': 'Redeemed',
          'value': 'REDEEMED',
          'color': 'green'
        },
        {
          'text': 'Debited',
          'value': 'DEBITED',
          'color': 'red'
        },
        {
          'text': 'Error',
          'value': 'ERROR',
          'color': 'grey'
        },
        {
          'text': 'Control Unit Error',
          'value': 'CONTROLUNITERROR',
          'color': 'red'
        }
      ];
    },
    paymentMethods () {
      return [
        {
          'text': 'Swish',
          'value': 'SWISH'
        },
        {
          'text': 'iZettle',
          'value': 'IZETTLE'
        },
        {
          'text': 'Bambora',
          'value': 'BAMBORA'
        },
        {
          'text': 'Card Checkout',
          'value': 'CARDCHECKOUT'
        },
        {
          'text': 'Gift Card',
          'value': 'GIFTCARD'
        }
      ];
    },
    operators () {
      var _operators = this.$store.getters['operators/items'];
      return _operators.map((operator) => {
        return {
          text: operator.name,
          value: operator.id
        }
      });
    },
    paymentsTotal () {
      var purchases = this.payments.filter((p) => !p.transactionType || p.transactionType == 'PURCHASE');
      var refunds = this.payments.filter((p) => p.transactionType == 'REFUND');
      var result = {
        purchases,
        refunds,
        purchasesAmount: {
          net: this.getAmountNet(purchases),
          gross: purchases.reduce((a, p) => a + (this.getAmount(p)), 0)
        },
        refundsAmount: {
          net: this.getAmountNet(refunds),
          gross: refunds.reduce((a, p) => a + (this.getAmount(p)), 0)
        },
        purchasesItemsCount: purchases.reduce((a, p) => a + ((p.items || []).length || 0), 0),
        refundsItemsCount: refunds.reduce((a, p) => a + ((p.items || []).length || 0), 0)
      };
      result.amount = {
        net: result.purchasesAmount.net - result.refundsAmount.net,
        gross: result.purchasesAmount.gross - result.refundsAmount.gross
      };
      result.itemCount = result.purchasesItemsCount - result.refundsItemsCount;
      return result;
    }
  },
  methods: {
    getAmount(payment) {
      return (payment.items || []).reduce((a, item) => {
        return a + item.price;
      }, 0);
    },
    getAmountNet(payments) {
      return payments.reduce((total, payment) => {
        var paymentTotal = (payment.items || []).reduce((a, item) => {
          return a + this.getNet(item.price, item.vat);
        }, 0);
        return total + paymentTotal;
      }, 0);
    },
    getNet (amount, vat) {
      // Get amount excl. VAT
      return amount / (1 + vat/100.0);
    },
    toggleSelected (selected, item, force) {
      var index = selected.indexOf(item.value);
      if (index != -1 && force != true) {
        selected.splice(index, 1);
      } else if (index == -1 && force != false) {
        selected.push(item.value);
      }
    },
    getStatus (statusValue) {
      var status = this.statuses.filter((s) => s.value == statusValue)[0];
      if (!status) {
        return null;
      }
      return status;
    },
    validTime (value) {
      return moment(value, 'HH:mm', true).isValid();
    },
    applyFilter () {
      // Deep copy to only get changes at apply
      this.appliedPaymentsFilter = JSON.parse(JSON.stringify((this.paymentsFilter)));
      if (this.$refs.baseItems) {
        this.$nextTick(() => {
          this.$refs.baseItems.triggerLoad();
          this.filterChanged = false;
        });
      } else {
        this.$snackbar({message: 'Could not apply filter', theme: 'error'});
      }
    },
    onError () {
      this.$snackbar({message: 'Failed to fetch orders', theme: 'error'});
      this.filterChanged = true;
    },
    reset () {
      this.datemenu = false;
      this.receiptId = '';
      this.dateFrom = null;
      this.dateTo = null;
      this.timeFrom = '';
      this.timeTo = '';
      this.selectedStatuses = ['PAID', 'REDEEMED', 'DEBITED'];
      this.selectedOperators = [];
    },
    openPaymentById (paymentId) {
      var payment = this.$store.getters['payments/getItemById'](paymentId);
      if (payment) {
        // Close previous to visulize change of payment object
        this.selectedPayment = null;
        setTimeout(() => {
          this.selectedPayment = payment;
        }, 250);
        return;
      }
      var promise = this.$store.dispatch('payments/fetchItemById', paymentId).then(() => {
        this.selectedPayment = this.$store.getters['payments/getItemById'](paymentId);
      }, () => {
        this.$snackbar({message: 'Failed to fetch payment', theme: 'error'});
      });
      this.selectedPayment = null;
      return promise;
    },
    openPayment (payment) {
      this.selectedPayment = payment;
    },
    closePayment () {
      this.selectedPayment = null;
    },
    padleft (val, ch, num) {
        var re = new RegExp(".{" + num + "}$");
        var pad = "";
        if (!ch) ch = " ";
        do {
            pad += ch;
        } while (pad.length < num);
        return re.exec(pad + val)[0];
    }
  },
  mounted () {
    this.$store.dispatch('operators/fetchItems');
  },
  components: {
    BaseItems,
    TimeInput,
    DateInput,
    Payment
  }
}
</script>

<style lang="css">

</style>
